<nz-upload
    (nzChange)="handleChange($event)"
    [nzAction]="url"
    [nzMultiple]="multiple"
    [nzAccept]="accept"
    nzShowUploadList="showUploadList"
    nzType="drag"
>
    <p class="ant-upload-drag-icon">
        <i nz-icon nzType="inbox"></i>
    </p>
</nz-upload>
<div *nzModalFooter>
    <button (click)="cancel()"
            nz-button>{{'Common.Cancel'|translate}}</button>
    <button (click)="upload()"
            nz-button
            nzType="primary">{{'Common.OK'|translate}}</button>
</div>
